/* INIZIO MODIFICA BIS GIORGIO — LCS INCISIONE (HELPER SINGLE SOURCE OF TRUTH) */
window.LCSIncisione = window.LCSIncisione || (function () {
  function getRoot(formEl) {
    return formEl ? (formEl.closest('product-form') || formEl) : null;
  }

  function getVariantId(formEl) {
    const idInput = formEl ? formEl.querySelector('input[name="id"]') : null;
    return idInput ? String(idInput.value || '') : '';
  }

  function readMap(formEl) {
    const root = getRoot(formEl);
    if (!root) return {};

    if (root.__lcsIncisioneMap) return root.__lcsIncisioneMap;

    const mapEl = root.querySelector('script[type="application/json"][data-lcs-incisione-map]');
    if (!mapEl) {
      root.__lcsIncisioneMap = {};
      return root.__lcsIncisioneMap;
    }

    try {
      root.__lcsIncisioneMap = JSON.parse(mapEl.textContent || '{}') || {};
    } catch (e) {
      root.__lcsIncisioneMap = {};
    }
    return root.__lcsIncisioneMap;
  }

  function getCfg(formEl) {
    const vid = getVariantId(formEl);
    const map = readMap(formEl);
    return (vid && map && map[vid]) ? map[vid] : { required: false, max: 0 };
  }

  function getUi(formEl) {
    const root = getRoot(formEl);
    if (!root) return {};
    return {
      wrap: root.querySelector('[data-lcs-incisione-wrap]'),
      input: root.querySelector('[data-lcs-incisione-input]'),
      help: root.querySelector('[data-lcs-incisione-help]')
    };
  }

  function refresh(formEl) {
    const cfg = getCfg(formEl);
    const ui = getUi(formEl);
    if (!ui.wrap || !ui.input) return;

    if (!cfg.required) {
      ui.wrap.style.display = 'none';
      ui.input.removeAttribute('required');
      ui.input.value = '';
      return;
    }

    ui.wrap.style.display = '';
    ui.input.setAttribute('required', 'required');

    const maxLen = (cfg.max && cfg.max > 0) ? cfg.max : 70;
    ui.input.setAttribute('maxlength', String(maxLen));
    if (ui.help) ui.help.textContent = 'Per questa variante puoi inserire fino a ' + maxLen + ' caratteri.';
  }

  function validate(formEl) {
    const cfg = getCfg(formEl);
    if (!cfg.required) return { ok: true };

    const ui = getUi(formEl);
    if (!ui.input) return { ok: false, message: 'Campo incisione non trovato. Ricarica la pagina.' };

    const maxLen = (cfg.max && cfg.max > 0) ? cfg.max : 70;
    const val = (ui.input.value ? ui.input.value : '').trim();

    if (!val) return { ok: false, message: 'Per questa variante è obbligatorio inserire il testo di incisione.' };
    if (val.length > maxLen) return { ok: false, message: 'Puoi inserire al massimo ' + maxLen + ' caratteri.' };

    return { ok: true };
  }

  function bindOnce(formEl) {
    const root = getRoot(formEl);
    if (!root || root.__lcsIncisioneBound) return;
    root.__lcsIncisioneBound = true;

    // refresh su change
    formEl.addEventListener('change', () => refresh(formEl));

    // eventi custom (a prova di tema)
    root.addEventListener('variant:change', () => refresh(formEl));
    root.addEventListener('variant-change', () => refresh(formEl));
    root.addEventListener('change', () => refresh(formEl));

    // monitor input[name=id]
    const idInput = formEl.querySelector('input[name="id"]');
    if (idInput) {
      const obs = new MutationObserver(() => refresh(formEl));
      obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });

      idInput.addEventListener('input', () => refresh(formEl));
      idInput.addEventListener('change', () => refresh(formEl));
    }

    refresh(formEl);
  }

  return { bindOnce, refresh, validate };
})();
/* FINE MODIFICA BIS GIORGIO — LCS INCISIONE (HELPER SINGLE SOURCE OF TRUTH) */


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        /* inizio INCISIONE — MOSTRA SUBITO IL CAMPO */
if (window.LCSIncisione) {
  window.LCSIncisione.bindOnce(this.form);
  window.LCSIncisione.refresh(this.form);
  requestAnimationFrame(() => window.LCSIncisione.refresh(this.form));
}
  /* fine INCISIONE — MOSTRA SUBITO IL CAMPO */
  /* INIZIO MODIFICA GIORGIO — SYNC CONSENSO CO-CREAZIONE */
this.syncCocreazioneConsent = () => {
  const isCocreazione = this.submitButton?.dataset?.cocreazione === 'true';
  const consentCheckbox = this.form.querySelector('[data-cocreazione-consent]');
  const consentError = this.form.querySelector('[data-cocreazione-consent-error]');

  if (!isCocreazione || !consentCheckbox) return;

  // Se il tema ha disabilitato per stock/quantity rules, non tocchiamo nulla.
  // NB: se invece eravamo noi ad averlo bloccato, lo segnamo con dataset.lcsConsentBlocked
  const disabledNow = this.submitButton.hasAttribute('disabled');
  const blockedByUs = this.submitButton.dataset.lcsConsentBlocked === '1';

  if (!consentCheckbox.checked) {
    // blocca sempre (se non è già bloccato dal tema per sold out)
    this.submitButton.setAttribute('disabled', 'disabled');
    this.submitButton.dataset.lcsConsentBlocked = '1';
  } else {
    // riabilita SOLO se era stato bloccato da noi (non sbloccare un sold-out del tema)
    if (disabledNow && blockedByUs) {
      this.submitButton.removeAttribute('disabled');
      delete this.submitButton.dataset.lcsConsentBlocked;
    }
    if (consentError) consentError.style.display = 'none';
  }
};

// Re-check quando cambia qualcosa nel form (variante o checkbox)
this.form.addEventListener('change', () => setTimeout(this.syncCocreazioneConsent, 0));

// Stato iniziale
setTimeout(this.syncCocreazioneConsent, 0);
/* FINE MODIFICA GIORGIO — SYNC CONSENSO CO-CREAZIONE */
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        /* INIZIO MODIFICA GIORGIO — BLOCCO SUBMIT SE CONSENSO MANCANTE */
if (this.submitButton?.dataset?.cocreazione === 'true') {
  const consentCheckbox = this.form.querySelector('[data-cocreazione-consent]');
  const consentError = this.form.querySelector('[data-cocreazione-consent-error]');

  if (consentCheckbox && !consentCheckbox.checked) {
    if (consentError) consentError.style.display = 'block';
    this.handleErrorMessage('Conferma il consenso per procedere.');
    consentCheckbox.focus();

    // riallinea anche lo stato del bottone (così vedi sempre il "divieto" coerente)
    if (typeof this.syncCocreazioneConsent === 'function') this.syncCocreazioneConsent();
    return;
  }
}
/* FINE MODIFICA GIORGIO — BLOCCO SUBMIT SE CONSENSO MANCANTE */
        /* INIZIO MODIFICA GIORGIO — CONSENSO CO-CREAZIONE (BLOCCO SUBMIT) */
if (this.submitButton?.dataset?.cocreazione === 'true') {
  const consentCheckbox = this.form.querySelector('[data-cocreazione-consent]');
  const consentError = this.form.querySelector('[data-cocreazione-consent-error]');

  if (consentCheckbox && !consentCheckbox.checked) {
    if (consentError) consentError.style.display = 'block';
    this.handleErrorMessage('Conferma il consenso per procedere.');
    consentCheckbox.focus();
    return;
  } else {
    if (consentError) consentError.style.display = 'none';
  }
}
/* FINE MODIFICA GIORGIO — CONSENSO CO-CREAZIONE (BLOCCO SUBMIT) */
/* INIZIO MODIFICA BIS GIORGIO — BLOCCO ADD TO CART (INCISIONE OBBLIGATORIA) */
if (window.LCSIncisione) {
  window.LCSIncisione.bindOnce(this.form);
  window.LCSIncisione.refresh(this.form);
  const res = window.LCSIncisione.validate(this.form);

  if (!res.ok) {
    this.handleErrorMessage(res.message);
    return;
  }
}
/* FINE MODIFICA BIS GIORGIO — BLOCCO ADD TO CART (INCISIONE OBBLIGATORIA) */

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
            });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');

          // Skip text update for cocreazione products - keep "Fissa Appuntamento"
          if (this.submitButton.dataset.cocreazione === 'true') {
            return;
          }

          if (this.submitButton.classList.contains('button--preorder')) {
            this.submitButtonText.textContent = window.variantStrings.preOrder;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
